import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";
import colors from "../../shared/constants/color";
import star1 from "../../shared/images/loading/star-1.svg";
import star2 from "../../shared/images/loading/star-2.svg";
import star3 from "../../shared/images/loading/star-3.svg";
import star4 from "../../shared/images/loading/star-4.svg";
import star5 from "../../shared/images/loading/star-5.svg";
import star6 from "../../shared/images/loading/star-6.svg";
import star7 from "../../shared/images/loading/star-7.svg";

interface IProps {
  title?: string;
  description?: string;
}

const stars = [star1, star2, star3, star4, star5, star6, star7];

const blink = keyframes`
  0%, 20%, 100% { opacity: 0; transform: scale(0.95); }
  10% { opacity: 1; transform: scale(1); }
`;

const AILoading: FC<IProps> = ({ title, description }) => {
  const duration = stars.length * 500;

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box
        position="relative"
        width={150}
        height={150}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {stars.map((star, i) => (
          <Box
            key={i}
            component="img"
            src={star}
            alt={`Star ${i + 1}`}
            sx={{
              position: "absolute",
              width: "150px",
              height: "150px",
              opacity: 0,
              animation: `${blink} ${duration}ms linear infinite`,
              animationDelay: `${i * 500}ms`,
            }}
          />
        ))}
      </Box>

      {title && (
        <Typography
          fontFamily="Inter"
          fontSize="16px"
          fontWeight={500}
          color={colors.blue.B500}
        >
          {title}
        </Typography>
      )}

      {description && (
        <Typography
          fontFamily="Inter"
          fontSize="12px"
          color={colors.neutral.N400}
          mt={1}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default AILoading;
